import { createLocalStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/local-storage/index.tsx';
import {
	BOARD_DETAIL_VIEW_MODE,
	DETAIL_VIEW_DEFAULT,
	type DETAIL_VIEW_SIDEBAR,
	type DETAIL_VIEW_MODAL,
	type SwimlaneModeId,
} from './constants';

export { swimlaneModeToStrategies } from './constants';

const localStorage = createLocalStorageProvider('software');

const GROUP_BY_SELECTION = 'gh.groupBySelection.';

type DetailViewMode =
	| typeof DETAIL_VIEW_DEFAULT
	| typeof DETAIL_VIEW_SIDEBAR
	| typeof DETAIL_VIEW_MODAL;

export const setBoardDetailViewMode = (detailViewMode: DetailViewMode) =>
	localStorage.set(BOARD_DETAIL_VIEW_MODE, detailViewMode);

export const getBoardDetailViewMode = (): DetailViewMode =>
	localStorage.get(BOARD_DETAIL_VIEW_MODE) || DETAIL_VIEW_DEFAULT;

export const getSwimlaneModeSetting = (boardId: string): SwimlaneModeId | null | undefined => {
	const data = localStorage.get(`${GROUP_BY_SELECTION}${boardId}`);

	if (!data) {
		return null;
	}

	return data;
};

// Issue Entry related types and methods

export type IssueId = number | string;

export type IssueEntryIssue = {
	type: 'issue';
	issueId: IssueId;
};

export type IssueEntryGroup = {
	type: 'group';
	parentId: IssueId;
	issueIds: IssueId[];
	isAttachedToParent: boolean;
};

export type IssueEntry = IssueEntryIssue | IssueEntryGroup;

export const isIssueEntryIssue = (issueEntry: IssueEntry): issueEntry is IssueEntryIssue =>
	issueEntry.type === 'issue';

export const isIssueEntryGroup = (issueEntry: IssueEntry): issueEntry is IssueEntryGroup =>
	issueEntry.type === 'group';

export const getIssueEntryGroupKey = ({ parentId, issueIds }: IssueEntryGroup) =>
	`${parentId}::${issueIds.join(',')}`;
